import React from 'react';

import hoistNonReactStatic from 'hoist-non-react-statics';

function scrollToTopOnMount(Component) {
    class ScrollToTopOnMount extends React.Component {
        componentDidMount() {
            const {
                location = {},
            } = this.props;
            const {
                hash,
            } = location;

            if (!hash) {
                window.scrollTo(0, 0);
            }
        }

        render() {
            return (
                <Component
                    {...this.props}
                />
            );
        }
    }

    return hoistNonReactStatic(ScrollToTopOnMount, Component);
}

export default scrollToTopOnMount;
